import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import axios from "axios";
import PageLoader from "../../PageLoader.jsx";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const Kyc = () => {
    const [loader, setLoader] = useState(true);
    const navigate = useNavigate();
    const user = useSelector((state) => state.user);
    const token = useSelector((state) => state.token);
    function getNewAccessToken() {
    }
    const applicantEmail = user.email;
    const applicantPhone = user.phone;

    const launchKycSdk = (accessToken) => {
        let snsWebSdkInstance = window.snsWebSdk.init(accessToken,() => getNewAccessToken())
            .withConf({
                lang: 'en',  // Default language; adjust if needed
                email: applicantEmail,
                phone: applicantPhone,
            })
            .withOptions({
                addViewportTag: false,
                adaptIframeHeight: true
            })
            .on('idCheck.onStepCompleted', (payload) => {
            })
            .on('idCheck.onError', (error) => {
                console.log('KycSdk onError', error);
            })
            .build();
        snsWebSdkInstance.launch('#sumsub-websdk-container');
    }

    useEffect(() => {
        if (user.kyc) {
            return navigate('/home');
        }
        axios({
            method: "POST",
            url: `${process.env.REACT_APP_BASE_URL}/user/kyc`,
            headers: {
                "Authorization": `Bearer ${token}`
            }
        }).then(res => {
            setLoader(false);
            launchKycSdk(res.data.token);
        }).catch(error => {
            toast(error?.response?.data?.message || error.message || "Failed to complete kyc", {
                position: "top-right",
                theme: "light",
                type: "error"
            });
            navigate('/home');
        });
    }, [applicantEmail, applicantPhone]);
    return (
        <>
            {loader ? <PageLoader /> : null}
            <div id="sumsub-websdk-container"></div>
        </>
    );
}

export default Kyc;